
import {defineComponent} from 'vue'
import { ReportFilter } from '@/model/models'

export default defineComponent( {
  name: 'ReportCheckBoxFilter',
  props: {
    filter: ReportFilter,
    preselect: null
  },
  created() {
    const selIndex = this.filter!.values.map(v => v[0]).indexOf(this.preselect)
    this.selected = selIndex >= 0 ? selIndex : 0
  },
  data() {
    return {
      selected: 0
    }
  },
  emits: [
    'filter-changed'
  ],
  methods: {
    onSelect(index: number) {
      this.selected = index

      const value = this.filter!.values[index]
      this.$emit('filter-changed', { name:  this.filter?.name, value: String(value[0]) })
    }
  },
  computed: {
    filterValues() {
      return  this.filter!.values.map(v => v[v.length-1])
    },
  }
})
